import React from 'react'
import { Route } from 'react-router'
import * as Views from './views'

const Routes = (
  <Route path="teaching-artist/:id" component={Views.TeachingArtist} />
)

export default Routes
